module.exports = __webpack_public_path__ + "img/check-box-large.d84ba3a2.svg";